export default __webpack_public_path__ + "static/media/longexposure_river.c4c02c57.jpg";